<template>
  <a-modal :title="`平台介绍(${state.platform_name})`" :width="1000" :open="true" @cancel="cancel">
    <template #footer>
      <a-button type="primary" @click="cancel">确定</a-button>
    </template>
    <a-spin :spinning="state.loading">
      <div v-html="state.intro" style="min-height: 300px; margin: 5px 0"></div>
    </a-spin>
  </a-modal>
</template>

<script lang="ts" setup>
import { SearchOutlined } from '@ant-design/icons-vue'
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, h, ref } from 'vue'
import { useStore } from 'vuex'
const emit = defineEmits(['cancel'])
const props = defineProps({
  platform_id: {
    type: Number,
    default: 0
  }
})

const state = reactive<any>({
  platform_name: '',
  intro: '',
  loading: false
})
onMounted(() => {
  queryDetail(props.platform_id)
})

const queryDetail = (id) => {
  state.loading = true
  let requeryParam = {
    url: `/admin/v1/platform/${id}/edit`,
    method: 'get'
  }
  baseService(requeryParam).then((res) => {
    state.loading = false
    state.platform_name = res.data.platform_abbreviation
    state.intro = res.data.platform_price_list
  })
}

const cancel = () => {
  emit('cancel')
}
</script>

<style lang="less" scoped>
:deep(.ant-modal-title) {
  margin-bottom: 25px !important;
}
</style>
